import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { depositHistoryApiConfig } from './depositHistory/constants'
import { fetchApiData as fetchDepositHistoryApiData } from './depositHistory/fetchApiData'
import { fetchSubTypes as fetchDepositHistorySubTypes } from './depositHistory/fetchSubTypes'
import { tradeHistoryApiConfig } from './tradeHistory/constants'
import { fetchApiData as fetchTradeHistoryApiData } from './tradeHistory/fetchApiData'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import { fetchApiData as fetchWithdrawalHistoryApiData } from './withdrawalHistory/fetchApiData'
import { fetchSubTypes as fetchWithdrawalHistorySubTypes } from './withdrawalHistory/fetchSubTypes'

export const bitbankApiConfigs = {
  /** 入金履歴 */
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  /** 約定履歴 */
  [tradeHistoryApiConfig.type]: tradeHistoryApiConfig,
  /** 出金履歴 */
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BitbankApiType = keyof typeof bitbankApiConfigs

export const bitbankApiTypes = Object.keys(
  bitbankApiConfigs,
) as BitbankApiType[]

export const fetchBitbankApiDataFuncs = {
  /** 入金履歴 */
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  /** 約定履歴 */
  [tradeHistoryApiConfig.type]: fetchTradeHistoryApiData,
  /** 出金履歴 */
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchBitbankSubTypesFuncs = {
  /** 入金履歴 */
  [depositHistoryApiConfig.type]: fetchDepositHistorySubTypes,
  /** 約定履歴 */
  [tradeHistoryApiConfig.type]: undefined,
  /** 出金履歴 */
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistorySubTypes,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentBitbankAssets } from './getCurrentAsset'
